module.exports = __webpack_public_path__ + "slick.ced611daf7709cc778da.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/slick/fonts/slick.eot
// module id = ../../../../../src/assets/slick/fonts/slick.eot
// module chunks = styles